import {EventEmitter, ElementRef, OnInit, Directive, Input, Output, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs';
import {NgModel} from '@angular/forms';
import {Subscription} from "rxjs/Subscription";
import "rxjs/add/operator/distinctUntilChanged";

@Directive({ selector: '[debounce-change]' })
export class DebounceChange implements OnInit, OnDestroy {
  @Input() delay: number = 700;
  @Output() chChange: EventEmitter<any> = new EventEmitter();

  private _eventStream: Subscription;
  constructor(private elementRef: ElementRef, private model: NgModel) {
  }

  ngOnInit(): void {
    this._eventStream = Observable.fromEvent(this.elementRef.nativeElement, 'keyup')
      .map(() => this.model.value)
      .debounceTime(this.delay)
      .distinctUntilChanged()
      .subscribe((input) => {
        this.chChange.emit(input)
      })
  }

  ngOnDestroy(): void {
    console.log('destroy debounce-change observable');
    this._eventStream.unsubscribe()
  }

}



// WEBPACK FOOTER //
// ./src/directives/debounce-change.ts